var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { uniqBy } from "lodash";
import PBService from "@irati/utils/services";
import client from "@irati/utils/services/apollo";
import authentication from "@irati/auth";
import dealsErrorHandler from "./errors/dealsErrorHandler";
import dealFavouritesQuery, { dealFavouritesQueryKey } from "./queries/dealFavourites";
import dealAddFavouriteMutation, { dealAddFavouriteMutationKey } from "./mutations/dealAddFavourite";
import dealRemoveFavouriteMutation, { dealRemoveFavouriteMutationKey } from "./mutations/dealRemoveFavourite";
var CompanyBenefitService = /** @class */ (function (_super) {
    __extends(CompanyBenefitService, _super);
    function CompanyBenefitService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompanyBenefitService.prototype.list = function (variables, options) {
        if (options === void 0) { options = {}; }
        return client.query(__assign(__assign({}, options), { query: dealFavouritesQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[dealFavouritesQueryKey];
        });
    };
    CompanyBenefitService.prototype.add = function (deal, options) {
        if (options === void 0) { options = {}; }
        var user = authentication.user();
        var variables = { userId: user.uuid, dealId: deal.uuid };
        this.addToFavouritesCache({ userId: user.uuid }, deal);
        return client.mutate(__assign(__assign({}, options), { mutation: dealAddFavouriteMutation, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[dealAddFavouriteMutationKey];
        });
    };
    CompanyBenefitService.prototype.remove = function (deal, options) {
        if (options === void 0) { options = {}; }
        var user = authentication.user();
        var variables = { userId: user.uuid, dealId: deal.uuid };
        this.removeFromFavouritesCache({ userId: user.uuid }, deal);
        return client.mutate(__assign(__assign({}, options), { mutation: dealRemoveFavouriteMutation, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[dealRemoveFavouriteMutationKey];
        });
    };
    CompanyBenefitService.prototype.listSync = function (variables) {
        try {
            var data = client.readQuery({ query: dealFavouritesQuery, variables: variables });
            var deals = data[dealFavouritesQueryKey];
            return deals;
        }
        catch (e) {
            // don't appear to have cache, lets fire and forget a list call, might have cache next time
            this.list(variables);
            return [];
        }
    };
    CompanyBenefitService.prototype.addToFavouritesCache = function (variables, deal) {
        var _a;
        var cache = this.listSync(variables);
        var newCache = uniqBy(__spreadArrays([deal], cache), "uuid");
        client.writeQuery({ query: dealFavouritesQuery, variables: variables, data: (_a = {}, _a[dealFavouritesQueryKey] = newCache, _a) });
    };
    CompanyBenefitService.prototype.removeFromFavouritesCache = function (variables, deal) {
        var _a;
        var cache = this.listSync(variables);
        var newCache = uniqBy(cache.filter(function (t) { return t.uuid !== deal.uuid; }), "uuid");
        client.writeQuery({ query: dealFavouritesQuery, variables: variables, data: (_a = {}, _a[dealFavouritesQueryKey] = newCache, _a) });
    };
    return CompanyBenefitService;
}(PBService));
export default new CompanyBenefitService({ errorHandlers: [dealsErrorHandler] });
